import React from "react";
import packageJson from "../../package.json";

export default function EnvironmentBanner() {
  const env = (process.env.REACT_APP_ENV || "").toLowerCase();
  const backendUrl = process.env.REACT_APP_BACKEND_URL || "";

  // Show if not production environment
  const isProd = env === "prod";

  if (isProd) {
    return null;
  }

  const version = packageJson?.version || "1.0.0";

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] bg-amber-500/90 text-amber-950 dark:bg-amber-600 dark:text-amber-50 px-3 py-1 text-xs font-semibold text-center flex items-center justify-center gap-2 shadow-sm backdrop-blur-xs select-none border-t border-amber-600/20">
      <span className="inline-block w-2 h-2 rounded-full bg-amber-900 dark:bg-amber-100 animate-pulse" />
      <span>{env} Environment</span>
      <span className="opacity-40">•</span>
      <span>v{version}</span>
    </div>
  );
}
